import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'kaz-input',
    templateUrl: './kaz-input.component.html',
    styleUrls: ['./kaz-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, FormsModule, FaIconComponent]
})
export class KazInputComponent {
  @Input('value') value: string = "";
  @Output('valueChange') valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() width: string = "100%";
  @Input() height: string = "3rem";
  @Input() placeholder: string = "Tippe etwas ein";
  @Input() title: string = "";
  @Input() inputType: 'text' | 'password' | 'number' = 'text';
  @Input() maxLength: number | undefined = undefined;
  @Input() showEye: boolean = false;
  @Input() capitalizeFirstLetter: boolean = false;
  @Input() disabled: boolean = false;
  @Input() class: string = '';


  showPassword: boolean = false;

  onInputChange(): void {
    if (this.inputType === 'text' && this.capitalizeFirstLetter){
      this.value = this.value.charAt(0).toUpperCase() + this.value.slice(1);
    }
    this.valueChange.emit(this.value);
  }

  onKeyDown(event: KeyboardEvent) {
    if (this.inputType === 'number') {
      const inputChar = event.key;
      const allowedKeys = [
        'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', 'Home', 'End'
      ];

      if (allowedKeys.includes(inputChar)) {
        return;
      }

      if (inputChar === '+') {
        if (this.value.length === 0) {
          return;
        } else {
          event.preventDefault();
          return;
        }
      }

      if (!/^[0-9]$/.test(inputChar)) {
        event.preventDefault();
      }
    }
  }

  changeInputType() {
    this.showPassword = !this.showPassword;
    if (this.showPassword)
      this.inputType = 'text';
    else
      this.inputType = 'password';
  }
}
